import { Editor } from '@monaco-editor/react'
import { SampleFormData } from '../../types/types'
import { useEffect, useState } from 'react'

type SchemaDataEditorProps = {
  data: SampleFormData
}

export const SchemaDataEditor = ({ data }: SchemaDataEditorProps) => {
  const [prefersDarkMode, setPrefersDarkMode] = useState(
    globalThis.matchMedia('(prefers-color-scheme: dark)').matches
  )
  useEffect(() => {
    const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: dark)')
    const handleChange = (event: MediaQueryListEvent) =>
      setPrefersDarkMode(event.matches)
    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])
  const theme = prefersDarkMode ? 'vs-dark' : 'light'

  const stringifiedData = JSON.stringify(data, null, 2)

  return (
    <Editor
      theme={theme}
      height='30vh'
      defaultLanguage='json'
      value={stringifiedData}
      options={{
        minimap: { enabled: false },
        automaticLayout: true,
        readOnly: true
      }}
    />
  )
}
